var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4469 25.33L25.6555 14.9706L23.483 16.1406L27.8777 23.9954L24.8983 23.2093C24.2527 23.0387 23.5885 23.4043 23.3899 24.032L22.3967 27.219L18.4427 19.9674L16.2453 21.1131L21.6084 30.9484C21.8257 31.3445 22.2415 31.5943 22.7009 31.5943C22.7443 31.5943 22.7816 31.5943 22.825 31.5882C23.3216 31.5395 23.7437 31.2043 23.8927 30.729L25.4072 25.8662L30.0379 27.085C30.702 27.2556 31.3786 26.8717 31.5586 26.2196C31.6393 25.921 31.6021 25.5981 31.4469 25.33Z",
    fill: "#00A0E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60355 27.219L8.61039 24.032C8.41176 23.4043 7.74758 23.0387 7.10202 23.2093L4.12254 23.9954L8.51728 16.1406L6.34474 14.9706L0.553359 25.33C0.224374 25.921 0.441628 26.6584 1.04373 26.9814C1.32306 27.1337 1.65204 27.1703 1.96241 27.091L6.59303 25.8723L8.1076 30.7351C8.25657 31.2043 8.67246 31.5456 9.17525 31.5943C9.2187 31.6004 9.25594 31.6004 9.2994 31.6004C9.75873 31.6004 10.1746 31.3506 10.3919 30.9545L15.7487 21.1131L13.5638 19.9614L9.60355 27.219Z",
    fill: "#00A0E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.997 21.8504C9.96978 21.8504 5.07225 17.0363 5.07225 11.1254C5.07225 5.21446 9.97599 0.400391 15.997 0.400391C22.0181 0.400391 26.9218 5.21446 26.9218 11.1254C26.9218 17.0363 22.0243 21.8504 15.997 21.8504ZM15.997 2.8318C11.3416 2.8318 7.54895 6.54899 7.54895 11.1254C7.54895 15.7018 11.3354 19.419 15.997 19.419C20.6587 19.419 24.4451 15.7018 24.4451 11.1254C24.4451 6.54899 20.6525 2.8318 15.997 2.8318Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2);
export default __webpack_public_path__ + "static/media/d2.ae3932524326b7ff2ec36b21d96cb2ca.svg";
export { ForwardRef as ReactComponent };